// composables/useExternalRedirect.js
import {Inertia} from "@inertiajs/inertia";

export function useExternalRedirect() {
    const redirectTo = (url) => {
        // Check if it's an external domain
        const currentDomain = window.location.hostname;
        const urlObject = new URL(url, window.location.origin);

        if (urlObject.hostname !== currentDomain) {
            // External domain - use window.location
            window.location.href = url;
        } else {
            // Same domain - use Inertia
            Inertia.visit(url);
        }
    };

    return { redirectTo };
}
